import React from "react";

export default function Animatespin() {
  return (
    <div className="flex items-center justify-center w-full">
      <div className="xs:w-8 xs:h-8 w-16 h-16 xs:border-2 border-4 border-orangeCrayola border-dashed rounded-full animate-spin"></div>
    </div>
  );
}
